import React from "react"


export default function RigaTabellaDato(dataInterno) {
    return <tr><td>{dataInterno.dataInterno.descrizione}</td>
        <td class="text-right">{dataInterno.dataInterno.valore}</td></tr>

}